import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { TemplateForm } from '@atlassian/proforma-common-core/form-system-models';

export type CreateFormResponse = {
	form: TemplateForm;
};

export function createForm(
	cloudId: string,
	projectId: number,
	template: TemplateForm,
): Promise<CreateFormResponse> {
	return performPostRequest(
		`/gateway/api/proforma/cloudid/${cloudId}/api/cloud/project/${projectId}/form`,
		{
			body: JSON.stringify(template),
		},
	);
}
